import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Instruction',
  props: {
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'Instruction'
    });
    return {
      __sfc: true,
      props: props,
      SIcon: SIcon
    };
  }
});